import { JBaseApi } from '../base';
import { OF } from '../../util/network';
import { ApiReturn, ApiWrapper, FormatList } from '../../types/utils';
import { CommunityAutocomplete } from '../../types/autocomplete';
import { jObjectLittle } from '../../types/objectBase';

export class JCommunityApi extends JBaseApi {
    public get<T extends FormatList = undefined>(idCommunity: string | number, format?: T) {
        return this.network.post<ApiReturn<T, jObjectLittle, jObjectLittle, jObjectLittle, jObjectLittle>>({
            o: 'community',
            f: 'getCommunity',
            idCommunity,
            format: format || 'raw-little',
        } as OF);
    }

    public sendRequest(message: string, idUserTo: number): Promise<ApiWrapper<boolean>> {
        return this.network.post({
            o: 'community',
            f: 'sendRequest',
            message,
            idUserTo,
        } as OF);
    }

    public autocomplete(q: string): Promise<CommunityAutocomplete[]> {
        return this.network
            .post<CommunityAutocomplete[]>({ o: 'autocomplete', f: 'community', q } as OF)
            .then((res) => res.result);
    }
}
